import { useState } from "react"
import Link from "next/link"
import cn from "classnames"
import getTelLink from "utilities/getTelLink"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import isInternalLink from "utilities/isInternalLink"
import Briefcase from "public/assets/briefcase.svg"
import MapPin from "public/assets/header-map-pin.svg"
import Phone from "public/assets/header-phone.svg"
import MagnifyingGlass from "public/assets/magnifying-glass.svg"

export default function CallToActionSubMenu({ ctaSubMenu, phoneNumbers }) {
  const [openDrawer, setOpenDrawer] = useState(false)

  function Icon({ link, label, children }) {
    return (
      <li>
        <Link href={link} className="flex flex-col items-center gap-1 font-secondary leading-none text-stone-light">
          <span className="h-8 text-stone-light">{children}</span>
          {label}
        </Link>
      </li>
    )
  }

  return (
    <div className="absolute bottom-0 left-0 right-0 z-[110] lg:relative">
      <div className="group relative ">
        <button
          className={cn(
            "cta-sub-menu flex w-full justify-between items-center gap-2 whitespace-nowrap border-[3px] text-evergreen bg-moss-light border-moss-light lg:border-aqua-mid lg:bg-aqua-mid px-8 py-2 text-left font-secondary text-m1 font-bold leading-none lg:text-stone-light lg:w-auto lg:rounded-full lg:px-6 lg:py-2 lg:hover:border-evergreen-mid lg:hover:bg-evergreen-mid",
            {
              open: openDrawer,
            },
          )}
          onClick={() => setOpenDrawer(!openDrawer)}
          onKeyDown={(e) => {
            if (e.code === "Return") {
              setOpenDrawer(!openDrawer)
            }
          }}
        >
          I Want To
        </button>
        <ul
          className={cn(
            "right-0 w-full origin-top divide-y overflow-hidden bg-stone-light px-6 transition-all duration-500 lg:rounded-10 lg:absolute lg:w-max lg:scale-y-0 lg:py-5 lg:text-right lg:shadow-[0px_4px_4px_rgba(0,0,0,0.25)] lg:focus-within:scale-y-100 lg:group-hover:scale-y-100",
            {
              "max-h-0 opacity-0 lg:max-h-max lg:opacity-100": !openDrawer,
              "lg:max-h-auto max-h-[500px] py-4 opacity-100": openDrawer,
            },
          )}
        >
          {ctaSubMenu?.menu_items?.map((item) => {
            const href = getStoryblokLink(item?.link)

            return (
              <li key={`menu-item-${item?._uid}`}>
                <Link
                  href={href}
                  target={isInternalLink(href) ? "_self" : "_blank"}
                  className="font-tertiary text-m1 font-medium uppercase leading-9 text-evergreen hover:underline"
                  tabIndex={openDrawer ? "0" : "-1"}
                >
                  {item?.label}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
      <div className="bg-evergreen px-4 py-3 lg:hidden">
        <ul className="grid w-full grid-cols-4 justify-items-center">
          <Icon link="/foundation/join-our-team" label="Careers">
            <Briefcase className="h-7 w-7" />
          </Icon>
          <Icon link="/about-us/contact-us" label="Directions">
            <MapPin />
          </Icon>
          <Icon link={getTelLink(phoneNumbers?.Main)} label="Contact">
            <Phone className="h-7 w-7" />
          </Icon>
          <Icon link="/search" label="Search">
            <MagnifyingGlass className="h-7 w-7" />
          </Icon>
        </ul>
      </div>
    </div>
  )
}
